import accessReducers from './access';
import fundingReducers from './funding';
import registrationReducers from './registration';
import userReducers from './user';

const reducers = {
  ...accessReducers,
  ...fundingReducers,
  ...registrationReducers,
  ...userReducers
};

export default reducers;
